export const PRICE_ARCHITECTURE_CONTRACT = 'ARQUITETURA_PRECOS';

export const hasPriceArchitectureAccess = (contratosAdicionais: readonly string[]) => contratosAdicionais.includes(PRICE_ARCHITECTURE_CONTRACT);
